export function getUnparsedURIParam(param) {
    const par = {};
    window.location.search.slice(1).split('&').forEach(elm => {
        if (elm === '')
            return;
        const spl = elm.split('=');
        par[spl[0]] = (spl.length >= 2 ? spl[1] : true);
    });
    if (par[param]) {
        return decodeURIComponent(par[param]);
    }
}
export const resolveSearchParams = (vm) => {
    const acceptor = getUnparsedURIParam('acceptor');
    if (acceptor)
        localStorage.setItem('acceptor', acceptor);
};
